import React from 'react';
import styled from 'styled-components';
import { PageSlice } from '@contracts';
import { useCountry } from '@hooks/useCountry';

interface SizedBoxProps {
  slice: PageSlice;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
const Spacer = styled.div<{ $slice: PageSlice }>`
  height: ${(props) => props.$slice.primary?.height?.text || '0'};
  ${(props) => props.$slice.primary?.background_color && `background: ${props.$slice.primary?.background_color};`};
  ${(props) => props.$slice.primary?.background?.text && `background: ${props.$slice.primary?.background?.text};`};

  @media (max-width: 1024px) {
    height: ${(props) => props.$slice.primary?.height_mobile?.text || props.$slice.primary?.height?.text};
  }
`;

export const SizedBox: React.FC<SizedBoxProps> = (props) => {
  const { country } = useCountry();
  const doNotShowIn = props.slice?.primary?.hide_in_countries?.text || '';

  if (doNotShowIn) {
    const countriesList = doNotShowIn.split(',');
    if (countriesList.includes(country)) {
      return null;
    }
  }

  return <Spacer $slice={props.slice} />;
};

export default SizedBox;
